var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEntregaValores(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-entrega-valores",
    transform: "translate(14612 18630)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2074",
    "data-name": "Rect\\xE1ngulo 2074",
    width: 46,
    height: 46,
    transform: "translate(-14612 -18630)",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_21023",
    "data-name": "Grupo 21023",
    transform: "translate(-14607 -18622)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "L\\xEDnea_339",
    "data-name": "L\\xEDnea 339",
    d: "M11.645.112H-.546a.693.693,0,0,1-.7-.681.693.693,0,0,1,.7-.681H11.645a.693.693,0,0,1,.7.681A.693.693,0,0,1,11.645.112Z",
    transform: "translate(12.708 30.334)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_20101",
    "data-name": "Grupo 20101",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_1397",
    "data-name": "Rect\\xE1ngulo 1397",
    d: "M2.815,1.362A1.387,1.387,0,0,0,1.407,2.724v20.56a1.387,1.387,0,0,0,1.407,1.362H33.1a1.387,1.387,0,0,0,1.407-1.362V2.724A1.387,1.387,0,0,0,33.1,1.362H2.815M2.815,0H33.1a2.771,2.771,0,0,1,2.815,2.724v20.56A2.771,2.771,0,0,1,33.1,26.008H2.815A2.771,2.771,0,0,1,0,23.284V2.724A2.771,2.771,0,0,1,2.815,0Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Sustracci\\xF3n_1",
    "data-name": "Sustracci\\xF3n 1",
    d: "M10.277,13.49H2.807A2.768,2.768,0,0,1,0,10.772V2.717A2.767,2.767,0,0,1,2.807,0h8.517a2.767,2.767,0,0,1,2.807,2.717V6.772H12.964V2.717a1.615,1.615,0,0,0-1.64-1.586H2.807a1.614,1.614,0,0,0-1.64,1.586v8.055a1.616,1.616,0,0,0,1.64,1.589h7.47v1.13Z",
    transform: "translate(5.07 2.772)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_1401_-_Contorno",
    "data-name": "Rect\\xE1ngulo 1401 - Contorno",
    d: "M2.808,1.132A1.614,1.614,0,0,0,1.17,2.717v8.058A1.614,1.614,0,0,0,2.808,12.36h8.517a1.614,1.614,0,0,0,1.638-1.585V2.717a1.614,1.614,0,0,0-1.638-1.585H2.808M2.808,0h8.517a2.763,2.763,0,0,1,2.808,2.717v8.058a2.763,2.763,0,0,1-2.808,2.717H2.808A2.763,2.763,0,0,1,0,10.775V2.717A2.763,2.763,0,0,1,2.808,0Z",
    transform: "translate(15.972 10.399)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_17089",
    "data-name": "Trazado 17089",
    d: "M5.2-.118H-.665A.576.576,0,0,1-1.25-.684.576.576,0,0,1-.665-1.25H5.2a.576.576,0,0,1,.585.566A.576.576,0,0,1,5.2-.118Z",
    transform: "translate(9.867 7.938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_17091",
    "data-name": "Trazado 17091",
    d: "M5.2-.118H-.665A.576.576,0,0,1-1.25-.684.576.576,0,0,1-.665-1.25H5.2a.576.576,0,0,1,.585.566A.576.576,0,0,1,5.2-.118Z",
    transform: "translate(20.772 15.635)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_17092",
    "data-name": "Trazado 17092",
    d: "M5.2-.118H-.665A.576.576,0,0,1-1.25-.684.576.576,0,0,1-.665-1.25H5.2a.576.576,0,0,1,.585.566A.576.576,0,0,1,5.2-.118Z",
    transform: "translate(20.772 19.259)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_17090",
    "data-name": "Trazado 17090",
    d: "M3.318-.118H-.665A.576.576,0,0,1-1.25-.684.576.576,0,0,1-.665-1.25H3.318A.576.576,0,0,1,3.9-.684.576.576,0,0,1,3.318-.118Z",
    transform: "translate(9.867 11.561)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEntregaValores);
export default __webpack_public_path__ + "static/media/icon-entrega-valores.92535b9bc2f76fe712c191980dcf5ed2.svg";
export { ForwardRef as ReactComponent };